import { render, staticRenderFns } from "./LayerAddingPermissionsListItem.vue?vue&type=template&id=4971eb96&scoped=true&"
import script from "./LayerAddingPermissionsListItem.vue?vue&type=script&lang=js&"
export * from "./LayerAddingPermissionsListItem.vue?vue&type=script&lang=js&"
import style0 from "./LayerAddingPermissionsListItem.vue?vue&type=style&index=0&id=4971eb96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4971eb96",
  null
  
)

export default component.exports